export interface BannerConfig {
  message: string;
  linkText?: string;
  linkUrl?: string;
  externalLinkText?: string;
  externalLinkUrl?: string;
  navigateTo?: string;
  closeIconSvg?: string;
  variant?: 'info' | 'warning' | 'error';
  position?: BannerPosition;
  show?: boolean;
}

export enum BannerPosition {
  FIXED = 'fixed',
  ABSOLUTE = 'absolute',
  RELATIVE = 'relative',
}
